import { useOnlinePeople } from "./PresenceProvider";

function initials(actor: string): string {
  const local = actor.split("@")[0] ?? actor;
  const parts = local.split(/[._-]+/).filter(Boolean);
  const letters = parts.slice(0, 2).map((p) => p[0]?.toUpperCase() ?? "");
  return letters.join("") || actor.slice(0, 2).toUpperCase();
}

/**
 * A compact "who is online" strip for the app header.
 *
 * Presence is a hint, not a gate: it says who Run Ledger can reach in-app right
 * now, which is also what decides whether a task is delivered here or delegated
 * out of app.
 */
export default function PresenceBar() {
  const people = useOnlinePeople();
  if (people.length === 0) return null;
  return (
    <div className="hidden lg:flex items-center gap-1" title="People in Run Ledger right now">
      <span className="inline-flex items-center gap-1 text-xs opacity-60">
        <span className="inline-block w-2 h-2 rounded-full bg-success" aria-hidden />
        {people.length} online
      </span>
      {people.slice(0, 5).map((person) => (
        <span
          key={person.actor}
          className="badge badge-ghost badge-sm"
          title={`${person.actor}${person.run_id ? " · on a run" : ""}`}
        >
          {initials(person.actor)}
        </span>
      ))}
      {people.length > 5 && <span className="text-xs opacity-50">+{people.length - 5}</span>}
    </div>
  );
}
